import { Controller } from "@hotwired/stimulus"

// Generic collapsible section controller
export default class extends Controller {
  static targets = ["content", "arrow"]
  static values = { open: { type: Boolean, default: false } }

  connect() {
    this.render()
  }

  toggle() {
    this.openValue = !this.openValue
    this.render()
  }

  render() {
    if (this.openValue) {
      this.contentTarget.classList.remove("hidden")
      if (this.hasArrowTarget) {
        this.arrowTarget.classList.add("rotate-180")
      }
    } else {
      this.contentTarget.classList.add("hidden")
      if (this.hasArrowTarget) {
        this.arrowTarget.classList.remove("rotate-180")
      }
    }

    this.element.querySelectorAll("[data-action~='click->collapsible#toggle']").forEach(trigger => {
      trigger.setAttribute("aria-expanded", this.openValue.toString())
    })
  }
}
